import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const FlagUS = () => (
    <svg width="16" height="12" viewBox="0 0 16 12" className="inline-block">
      <rect width="16" height="12" fill="#B22234"/>
      <rect width="16" height="1" y="1" fill="white"/>
      <rect width="16" height="1" y="3" fill="white"/>
      <rect width="16" height="1" y="5" fill="white"/>
      <rect width="16" height="1" y="7" fill="white"/>
      <rect width="16" height="1" y="9" fill="white"/>
      <rect width="16" height="1" y="11" fill="white"/>
      <rect width="6" height="7" fill="#3C3B6E"/>
    </svg>
  );

  const FlagDE = () => (
    <svg width="16" height="12" viewBox="0 0 16 12" className="inline-block">
      <rect width="16" height="4" fill="#000000"/>
      <rect width="16" height="4" y="4" fill="#DD0000"/>
      <rect width="16" height="4" y="8" fill="#FFCE00"/>
    </svg>
  );

  const languages = [
    { code: 'en', name: 'English', flag: <FlagUS /> },
    { code: 'de', name: 'Deutsch', flag: <FlagDE /> }
  ];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);

    const url = new URL(window.location.href);
    if (languageCode === 'en') {
      url.searchParams.delete('lang');
    } else {
      url.searchParams.set('lang', languageCode);
    }
    window.history.replaceState({}, '', url.toString());
  };

  return (
    <div className="flex items-center gap-2">
      {languages.map((language) => (
        <button
          key={language.code}
          onClick={() => handleLanguageChange(language.code)}
          className={`flex min-h-[40px] items-center gap-1 rounded-full border px-3 py-2 font-code text-[11px] font-semibold uppercase tracking-[0.12em] transition-colors duration-200 ${
            i18n.language === language.code
              ? 'border-primary-container/40 bg-primary-container/10 text-primary-container shadow-[0_0_18px_rgba(0,242,255,0.12)]'
              : 'border-white/10 bg-white/[0.03] text-on-surface-variant hover:bg-primary-container/10 hover:text-primary-container'
          }`}
          title={language.name}
        >
          <span className="flex items-center">{language.flag}</span>
          <span className="hidden sm:inline">{language.code.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;